<template>
  <svg :class="direction" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19M19 12L12 5M19 12L12 19" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      required: true,
      validator: value => ['left', 'right', 'up', 'down'].includes(value),
    },
    color: {
      type: String,
      default: '#FB923C',
      required: false,
    }
  }
};
</script>

<style lang="scss" scoped>
.left {
  transform: rotate(-180deg);
}

.up {
  transform: rotate(-90deg);
}

.down {
  transform: rotate(90deg);
}
</style>
